'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createAccountTrigger = require('../../auth/create-account-trigger');

var _createAccountTrigger2 = _interopRequireDefault(_createAccountTrigger);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SignUpButton = _react2['default'].createClass({
    displayName: 'SignUpButton',


    propTypes: {
        'googleOpenIdUrl': _react2['default'].PropTypes.string.isRequired,
        'useWhite': _react2['default'].PropTypes.bool,
        'useBlack': _react2['default'].PropTypes.bool,
        'isCompact': _react2['default'].PropTypes.bool,
        'isMobile': _react2['default'].PropTypes.bool,
        'signupUrl': _react2['default'].PropTypes.string,
        'useRegularLink': _react2['default'].PropTypes.bool,
        'buttonText': _react2['default'].PropTypes.string,
        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'async': _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            useWhite: false
        };
    },
    render: function render() {

        var classSet = (0, _classnames2['default'])({
            'm-link-list--link': !this.props.isMobile,
            'm-link-list--signup': !this.props.isMobile,
            'm-link-list--link-break-2': !this.props.isMobile,
            'm-mobile-menu--signup-link': this.props.isMobile,
            'bg-cerulean': !this.props.useWhite,
            'bg-white': this.props.useWhite && !this.props.useBlack,
            'bg-ashen': this.props.useBlack,
            'c-white': !this.props.useWhite || this.props.useBlack,
            'c-cerulean': this.props.useWhite,
            'hc-cerulean': this.props.useWhite,
            'hc-white': !this.props.useWhite,
            'hbg-velvet-evening': !this.props.useWhite,
            'hbg-warm-chinchilla': !this.props.useBlack && this.props.useWhite,
            'hbg-ashen': this.props.useBlack
        });

        var triggerClasses = (0, _classnames2['default'])({
            'm-link-list--link--container': true,
            'is-compact': this.props.isCompact
        });
        var trigger = _react2['default'].createElement(
            'div',
            { className: triggerClasses },
            _react2['default'].createElement(
                'a',
                { className: classSet, href: this.props.useRegularLink ? this.props.signupUrl : 'javascript:;', tabIndex: '-1' },
                this.props.buttonText ? this.props.buttonText : 'Sign Up'
            )
        );

        if (this.props.useRegularLink) {
            var returnValue = trigger;
        } else {
            var returnValue = _react2['default'].createElement(_createAccountTrigger2['default'], {
                key: 'signup_trigger',
                trigger: trigger,
                header: 'Let\'s get started',
                buttonText: 'Create an account',
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                signupUrl: this.props.signupUrl,
                signupForm: this.props.signupForm,
                loginForm: this.props.loginForm,
                recoverPasswordForm: this.props.recoverPasswordForm,
                async: this.props.async
            });
        }

        return returnValue;
    }
});

module.exports = SignUpButton;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/top-bar-menu/signup-button.jsx
 ** module id = 1028
 ** module chunks = 0
 **/